import { render, staticRenderFns } from "./AlertTooltip.vue?vue&type=template&id=53112946&"
import script from "./AlertTooltip.vue?vue&type=script&lang=js&"
export * from "./AlertTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports